export default [
    "#FD1800FF",
    "#CB985EFF",
    "#386418FF",
    "#007994FF",
    "#DE6E00FF",
    "#9D00FDFF",
    "#221F1FFF"
];